import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SmartHomeComponent } from '@vi-iot/client/apis/smart-home-components/smart-home-components.model';
import { smartHomeComponentsMockedResponse } from '@vi-iot/client/apis/smart-home-components/smart-home-components.mocked-response';
import { mockEndpointDelay } from '@vi-iot/client';
import { delay } from 'rxjs/operators';

@Injectable()
export class SmartHomeComponentsMockApi {
  constructor() {}

  listSmartHomeComponents(_installationId: number): Observable<{ data: SmartHomeComponent[] }> {
    return of({ data: smartHomeComponentsMockedResponse }).pipe(delay(mockEndpointDelay));
  }

  updateSmartHomeComponents(
    _installationId: number,
    _smartHomeComponents: SmartHomeComponent[]
  ): Observable<{ data: SmartHomeComponent[] }> {
    return of({ data: _smartHomeComponents }).pipe(delay(mockEndpointDelay));
  }
}
